<div style="position:absolute; right:0; top:0; padding:20px; z-index:1;">
	<div style="display: flex; align-items: center; justify-content: center;">
		<span *ngIf="allowCancel" (click)="cancel($event)" role="button" class="jmCloseBtn"></span>
	</div>
</div>
<!--this should be modified to show only forms (images shown on signup-login-reset-password.component.html)-->
<div class="componentFormContainer">

	<!--person name-->
	<ng-container *ngIf="steps[currentStep].name==='name'">
		<div style="margin-bottom: 10px; margin-top: 20px;">Start your Journey</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Sign up for <span class="gColorAccentPrimary">free</span></h1>

		<label for="txtFirstName" class="form-label">First Name</label>		
		<input #txtFirstName
			   [(ngModel)]="frmSignup.firstName"
			   id="txtFirstName"
			   type="text"
			   class="form-control gFormInput"
			   [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'"
			   autocomplete="off"
			   maxlength="50"
			   placeholder="Enter your first name"
			   (keyup)="checkName($event, null)"
			   (keydown)="checkName($event, null)"
			   (focus)="checkName($event, null)" />

		<label for="txtLastName" class="form-label">Last Name</label>
		<input [(ngModel)]="frmSignup.lastName"
			   id="txtLastName"
			   type="text"
			   autocomplete="off"
			   maxlength="50"
			   placeholder="Enter your last Name"
			   class="form-control gFormInput"
			   (keyup)="checkName($event, null)"
			   (keydown)="checkName($event, null)"
			   (focus)="checkName($event, null)" />

		<div style="display: none;">
			<!-- chrome will auto fill the 2nd fields with password, so have this fool chrome browser-->
			<input type="text" id="txtHideMe" style="border:none; background-color:#e4bcb4; width:0px;" tabindex="0" />
		</div>

		<div class="message" [innerHTML]="frmSignup.nameMsg"></div>

		<div class="loadingSpinnerContainer" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">
			<div *ngIf="!isWaiting" style="width: 100%;"><button type="button" class="btn btn-lg btn-primary" (click)="checkName($event, currentStep+1)" style="width: 100%;" [ngClass]="(frmSignup.firstName !== '' && frmSignup.lastName !== '')?'':'disabled'">Next</button></div>
			<div *ngIf="isWaiting" style="font-size: 16px;"><span class="jmWidgetLoadingIcon20"></span></div>
		</div>
	</ng-container>
	<!--by email-->
	<ng-container *ngIf="steps[currentStep].name==='username' && frmSignup.byEmail">
		<div style="margin-bottom: 10px; margin-top: 20px;">Start your Journey</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Your <span class="gColorAccentPrimary">email</span> goes here</h1>

		<label for="txtEmail" class="form-label">Email Address</label>		
		<input *ngIf="anonymousUserLink === ''"
			   #txtEmail
			   [(ngModel)]="frmSignup.email"
			   id="txtEmail" type="text"
			   style="margin-bottom: 10px;"
			   class="form-control gFormInput"
			   autocomplete="off"
			   autocapitalize="off"
			   maxlength="50"
			   placeholder="Enter your Email"
			   (keyup)="checkUsername($event,null)"
			   (keydown)="checkUsername($event,null)" />

		<input *ngIf="anonymousUserLink !== ''"
			   [(ngModel)]="frmSignup.email"
			   id="txtEmail"
			   style="margin-bottom: 10px;"
			   type="text"
			   class="form-control gFormInput"
			   tabindex="-1"
			   readonly="readonly" />

		<div *ngIf="anonymousUserLink === ''" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'" class="gTextCaption">
			No email? Create an account <a href="javascript:void(0);" tabindex="-1" (click)="toggleUsernameEmail()" class="gTextBold">with a username</a> instead.
		</div>

		<div class="message" [innerHTML]="frmSignup.usernameMsg"></div>

		<div class="loadingSpinnerContainer" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">
			<ng-container *ngIf="!isWaiting" style="width: 100%;"><button #btnUsername type="button" id="btnUsername" class="btn btn-lg btn-primary" (click)="checkUsername($event, currentStep+1)" style="width: 100%;" [ngClass]="(frmSignup.username !== '' || frmSignup.email !== '')?'':'disabled'">Next</button></ng-container>
			<ng-container *ngIf="isWaiting" style="font-size: 16px;"><span class="jmWidgetLoadingIcon20"></span></ng-container>
		</div>
	</ng-container>
	<!--by username-->
	<ng-container *ngIf="steps[currentStep].name==='username' && !frmSignup.byEmail && anonymousUserLink === ''">
		<div style="margin-bottom: 10px; margin-top: 20px;">Start your Journey</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Let's make a <span class="gColorAccentPrimary">username</span></h1>

		<label for="txtUsername" class="form-label">Username</label>
		<input #txtUsername
			   [(ngModel)]="frmSignup.username"
			   id="txtUsername"
			   type="text"
			   style="margin-bottom: 10px;"
			   class="form-control gFormInput"
			   autocomplete="off"
			   autocapitalize="off"
			   maxlength="50"
			   placeholder="Enter Your Username"
			   (keyup)="checkUsername($event,null)"
			   (keydown)="checkUsername($event,null)" />
		<div [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'" class="gTextCaption">
			Create an account<a href="javascript:void(0);" tabindex="-1" (click)="toggleUsernameEmail()" class="gTextBold"> with your email</a> instead.
		</div>
		<div class="message" [innerHTML]="frmSignup.usernameMsg"></div>
		<div class="loadingSpinnerContainer" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">
			<ng-container *ngIf="!isWaiting" style="width: 100%;"><button type="button" class="btn btn-lg btn-primary" (click)="checkUsername($event, currentStep+1)" style="width: 100%;" [ngClass]="(frmSignup.username !== '' || frmSignup.email !== '')?'':'disabled'">Next</button></ng-container>
			<ng-container *ngIf="isWaiting" style="font-size: 16px;"><span class="jmWidgetLoadingIcon20"></span></ng-container>
		</div>
	</ng-container>
	<!--password-->
	<ng-container *ngIf="steps[currentStep].name==='password'">
		<div style="margin-bottom: 10px; margin-top: 20px;">Start your Journey</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Let's keep your account <span class="gColorAccentPrimary">safe</span> and <span class="gColorAccentPrimary">secure</span></h1>

		<div style="position: relative; display: flex; flex-direction: column;">

			<label for="txtPw1" class="form-label">Password</label>
			<div style="position: relative;">
				<input #txtPw1
					   style="width: 100%;"
					   [(ngModel)]="frmSignup.pw1"
					   id="txtPw1"
					   type="password"
					   [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'"
					   class="form-control gFormInput"
					   autocomplete="off"
					   autocapitalize="off"
					   maxlength="50"
					   placeholder="Password"
					   (keydown)="checkPassword($event,null)"
					   (focus)="checkPassword($event,null)"
					   (keyup)="checkPassword($event,null)"
					   (blur)="checkPassword($event,null)" />
				<i tabindex="-1" class="jmActionIcon jmPrimaryForeground inputIcon" [ngClass]="(txtPw1Type === 'password')?'fas fa-eye-slash':'fas fa-eye'" (click)="showPassword('txtPw1')"></i>
			</div>
			<div [style.display]="pw1isFocused?'':'none'" style="position: absolute; top: 72px; right: 0; width: 70%; z-index: 2;">
				<div style="z-index: 2; width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid #28275a; position: absolute; right: 20px; ">
					<div style="width: 0; height: 0; border-left: 8px solid transparent; border-right: 8px solid transparent; border-bottom: 8px solid white; right: -8px; transform: translateY(1px); z-index: 3; position: absolute;">
					</div>
				</div>
				<div style="border-style: solid; border-width: 1px; background-color: white; border-color: #28275a; border-radius: 8px; transform: translateY(8px); padding: 10px;">
					<div style="margin-bottom: 10px;" class="gTextBold">Password <span class="gColorAccentPrimary">Criteria</span></div>
					<ul class="gTextCaption">
						<li>Must be at least 6 characters</li>
						<li>Include 1 upper case or 1 numeric value</li>
					</ul>
					<!--Password length must be at least 6 characters <br />and <br />include 1 upper case <br />or <br />1 numeric value.-->
				</div>
			</div>
		</div>
		<label for="txtPw2" class="form-label">Re-enter Password</label>
		<div style="position: relative;">
			<input #txtPw2
				   [(ngModel)]="frmSignup.pw2"
				   id="txtPw2"
				   style="width: 100%;"
				   type="password"
				   [ngClass]="(showMinimize)?'verticalSpacing20btm':'verticalSpacing25btm'"
				   class="form-control gFormInput"
				   autocomplete="off"
				   autocapitalize="off"
				   maxlength="50"
				   placeholder="Re-enter Password"
				   (keyup)="checkPassword($event,null)"
				   (focus)="checkPassword($event,null)"
				   (keydown)="checkPassword($event,null)" />
			<i tabindex="-1" class="jmActionIcon jmPrimaryForeground inputIcon" [ngClass]="(txtPw2Type === 'password')?'fas fa-eye-slash':'fas fa-eye'" (click)="showPassword('txtPw2')"></i>
		</div>
		<div class="message" [innerHTML]="frmSignup.pwMsg"></div>
		<div class="loadingSpinnerContainer" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">
			<ng-container *ngIf="!isWaiting" style="width: 100%;"><button #btnPwNext type="button" class="btn btn-lg btn-primary" id="btnPwNext" (click)="checkPassword($event, currentStep+1)" style="width: 100%; z-index: 1;" [ngClass]="(frmSignup.pw1.length > 0 && frmSignup.pw2.length > 0)?'':'disabled'">Next</button></ng-container>
			<ng-container *ngIf="isWaiting" style="font-size: 16px;"><span class="jmWidgetLoadingIcon20"></span></ng-container>
		</div>
	</ng-container>
	<!--birthday-->
	<ng-container *ngIf="steps[currentStep].name==='dob'">
		<div style="margin-bottom: 10px; margin-top: 20px;">Start your Journey</div>
		<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">It's your <span class="gColorAccentPrimary">birthday</span>! When do we <span class="gColorAccentPrimary">party</span>?</h1>

		<div style="display: flex; flex-direction: row; justify-content: space-around;" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">
			<div style="display: flex; flex-direction: column; align-items: center;">
				<label for="txtDobMonth" class="form-label">Month</label>
				<!--[ngClass]="frmSignup.dobMonthStatus==null?'jmUnderline':frmSignup.dobMonthStatus===true?'jmUnderlineOk':'jmUnderlineError'"-->
				<input #txtDobMonth
					   [(ngModel)]="dobMonthDisplay"
					   id="txtDobMonth"
					   type="text"
					   inputmode="numeric"
					   class="form-control gFormInput"
					   autocomplete="off"
					   maxlength="2"
					   placeholder="MM"
					   (keyup)="checkDOB($event,null)"
					   (keydown)="checkDOB($event,null)"
					   style="width: 5em;
				   text-align: center;" />
			</div>
			<div style="display: flex; flex-direction: column; align-items: center;">
				<label for="txtDobDate" class="form-label">Day</label>
				<!--[ngClass]="frmSignup.dobDateStatus==null?'jmUnderline':frmSignup.dobDateStatus===true?'jmUnderlineOk':'jmUnderlineError'"-->
				<input #txtDobDate
					   [(ngModel)]="dobDateDisplay"
					   id="txtDobDate"
					   type="text"
					   inputmode="numeric"
					   class="form-control gFormInput"
					   autocomplete="off"
					   maxlength="2"
					   placeholder="DD"
					   (keyup)="checkDOB($event,null)"
					   style="width: 5em;
				   text-align: center;" />
			</div>
			<div style="display: flex; flex-direction: column; align-items: center;">
				<label for="txtDobDate" class="form-label">Year</label>
				<!--[ngClass]="frmSignup.dobYearStatus==null?'jmUnderline':frmSignup.dobYearStatus===true?'jmUnderlineOk':'jmUnderlineError'"-->
				<input #txtDobYear
					   [(ngModel)]="dobYearDisplay"
					   id="txtDobYear"
					   type="text"
					   inputmode="numeric"
					   min="{{minYear}}"
					   max="{{maxYear}}"
					   class="form-control gFormInput"
					   autocomplete="off"
					   maxlength="4"
					   placeholder="YYYY"
					   (keyup)="checkDOB($event,null)"
					   style="width: 5em;
				   text-align: center;" />
			</div>
		</div>

		<div [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">


			<div *ngIf="frmSignup.dobStatus===null && frmSignup.dobMsg != ''" style="margin-top: 10px;">
				Type your birthday date like this:
				<br />
				MM DD YYYY
				<br />
				Example: 02 22 2002
			</div>
			<div [innerHTML]="frmSignup.dobMsg" class="message"></div>

			<div class="loadingSpinnerContainer">
				<div *ngIf="!isWaiting" style="width: 100%;">
					<div *ngIf="frmSignup.dobAge != null && frmSignup.dobAge < 13" style="width: 100%;">
						<button type="button" id="btnGotPermission" class="btn btn-lg btn-primary" (click)="checkDOB($event, currentStep+1)" tabindex="-1" style="width: 100%;">I got permission!</button>
					</div>

					<div *ngIf="frmSignup.dobAge === null || frmSignup.dobAge >= 13" style="width: 100%;">
						<button type="button" class="btn btn-lg btn-primary" (click)="checkDOB($event, currentStep+1)" style="width: 100%;" [ngClass]="(dobMonthDisplay.length > 0 && dobDateDisplay.length > 0 && dobYearDisplay.length > 0)?'':'disabled'">Next</button>
					</div>
				</div>
				<div *ngIf="isWaiting" style="font-size: 16px;"><span class="jmWidgetLoadingIcon20"></span></div>
			</div>
		</div>
	</ng-container>
	<!--connection-->
	<ng-container *ngIf="steps[currentStep].name==='connection'">
		<div style="margin-bottom: 10px; margin-top: 20px;">Start your Journey</div>
		<div [hidden]="frmSignup.connectionSkip===false">
			<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'">Do you have a <span class="gColorAccentPrimary">connection code</span>?</h1>

			<div style="display: flex; flex-direction: row; justify-content: center;" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'">
				<button type="button" class="btn btn-lg btn-outline-primary" (click)="toggleConnect(false)" tabindex="-1" style="width: 100px;">No</button>
				<button type="button" class="btn btn-lg btn-primary" (click)="toggleConnect(true)" tabindex="-1" style="width: 100px; margin-left: 20px;">Yes</button>
			</div>

			<div style="text-align: center;">Not sure what this is? Don't feel bad, just <a href="javascript:void(0);" style="color: #1D81F8;" (click)="toggleConnect(false)">skip</a> ahead!</div>
			<div [innerHTML]="frmSignup.connectionMsg" class="message"></div>
		</div>


		<div [hidden]="frmSignup.connectionSkip===true">
			<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Connect with your<span class="gColorAccentPrimary"> code</span>!</h1>

			<div style="display: flex; flex-direction: column; margin-bottom: 10px;">
				<label for="txtConnection" class="form-label">Connection Code</label>
				<input #txtConnection
					   [(ngModel)]="frmSignup.connection"
					   id="txtConnection"
					   type="text"
					   class="form-control gFormInput"
					   autocomplete="off"
					   maxlength="50"
					   placeholder="Enter Connection Code"
					   (keydown)="checkConnection($event,null)" />
			</div>
			<div [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'">Not sure what this is? Don't feel bad, just <a href="javascript:void(0);" style="margin-top: 10px;" (click)="toggleConnect(false)">skip</a> ahead!</div>

			<div [innerHTML]="frmSignup.connectionMsg" class="message"></div>

			<button type="button" class="btn btn-lg btn-primary" (click)="checkConnection($event, currentStep+1)" style="width: 100%;" [ngClass]="(frmSignup.connection.length > 0)?'':'disabled'">Next</button>

		</div>

	</ng-container>

	<!--processing screen-->
	<ng-container *ngIf="steps[currentStep].name==='final'">
		<div *ngIf="isWaiting" style="font-size: 16px;" class="loadingSpinnerContainer">
			<span class="jmWidgetLoadingIcon20"></span>
		</div>

		<div *ngIf="alreadySignup">
			Sign up is already complete.
			Please <a (click)="goLogin()">login</a>.
		</div>

		<div *ngIf="!(alreadySignup)">
			<!--<div style="margin-bottom: 10px; margin-top: 20px;">Processing....</div>-->
			<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Processing...</h1>

			<ng-container *ngIf="usernameTaken">
				<ng-container *ngIf="frmSignup.byEmail">
					That email is taken.Try another or <span type='button' (click)='goLogin()' class="gColorAccentPrimary">Sign in</span> instead.
				</ng-container>
				<ng-container *ngIf="!frmSignup.byEmail">
					That username is taken.Try another or <span type='button' (click)='goLogin()' class="gColorAccentPrimary">Sign in</span> instead."
				</ng-container>
			</ng-container>

			<div class="message" *ngIf="!usernameTaken">
				<span [innerHTML]="signupMsg"></span>
			</div>

			<button type="button" *ngIf="!doneSignup&&!isWaiting" class="btn btn-primary" style="width: 100%; margin-top: 20px;" (click)="reviewRetry();">Review & Retry</button>

		</div>
	</ng-container>
</div>
